<template>
  <textarea
    ref="textareaRef"
    v-model="modelValue"
    data-slot="textarea"
    :class="
      cn(
        'tw:border-input tw:placeholder:text-muted-foreground tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive tw:dark:bg-input/30 tw:flex tw:field-sizing-content tw:min-h-16 tw:w-full tw:rounded-md tw:border tw:bg-transparent tw:px-3 tw:py-2 tw:text-base tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none tw:focus-visible:ring-[3px] tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm',
        'tw:[&.is-invalid]:ring-destructive/20 tw:dark:[&.is-invalid]:ring-destructive/40 tw:[&.is-invalid]:border-destructive',
        'tw:md:text-base tw:field-sizing-fixed',
        props.class,
      )
    "
  />
</template>

<script setup>
import { useVModel } from '@vueuse/core'
import { useTemplateRef } from 'vue'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
  defaultValue: { type: [String, Number], required: false },
  modelValue: { type: [String, Number], required: false },
})

const emits = defineEmits(['update:modelValue'])

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const textareaRef = useTemplateRef('textareaRef')
defineExpose({
  textareaRef,
})
</script>
